import { render, staticRenderFns } from "./OutstandingCreditListSideMenu.vue?vue&type=template&id=c8f1a59c&scoped=true"
import script from "./OutstandingCreditListSideMenu.vue?vue&type=script&lang=js"
export * from "./OutstandingCreditListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1a59c",
  null
  
)

export default component.exports